<template>
  <div class="container-fluid mt--12">
    <actions-declaracao-inss/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <lista-declaracao-inss/>
      </div>
    </div>
  </div>
</template>

<script>
import DeclaracaoInssListaDetalhada from "./DeclaracaoInssListaDetalhada";
import DeclaracaoInssActions from "./DeclaracaoInssActions";
export default {
  name: "DeclaracaoInssContainerLista",
  components: {
    "lista-declaracao-inss": DeclaracaoInssListaDetalhada,
    "actions-declaracao-inss": DeclaracaoInssActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssContainerLista.vue